module.exports = __webpack_public_path__ + "static/media/bx-user-circle.599bd7b3.svg";